import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AccountList from './components/AccountList';
import AddAccountFlow from './components/AddAccountFlow';

export type ViewType = 'list' | 'add';

export default function BrokerBindPage() {
  const navigate = useNavigate();
  const [view, setView] = useState<ViewType>('list');

  return (
    <div className="min-h-screen bg-gray-50 pb-28">
      {/* Header */}
      <div className="bg-white border-b border-gray-100 px-5 pb-4" style={{ paddingTop: 'max(env(safe-area-inset-top, 0px), 48px)' }}>
        <div className="flex items-center gap-3">
          <button
            onClick={() => view === 'add' ? setView('list') : navigate(-1)}
            className="w-8 h-8 flex items-center justify-center"
          >
            <i className="ri-arrow-left-s-line text-gray-600 text-xl" />
          </button>
          <h1 className="text-gray-900 font-bold text-lg flex-1">
            {view === 'add' ? '添加交易账户' : '交易账户管理'}
          </h1>
        </div>
      </div>

      <div className="mt-5">
        {view === 'list' ? (
          <AccountList onAddNew={() => setView('add')} />
        ) : (
          <AddAccountFlow onSuccess={() => setView('list')} onCancel={() => setView('list')} />
        )}
      </div>
    </div>
  );
}
